module.exports = __webpack_public_path__ + "img/syukyaku-top-006.c665355a.jpg";